import { getAuthorizationToken } from "../utils/tokenUtils";
import { PublicClientApplication, AccountInfo } from "@azure/msal-browser";

const fetchPdfToken = async (
    msalInstance: PublicClientApplication,
    account: AccountInfo | null,
    authority: string,
    logout: () => void
): Promise<string | null> => {
    try {
        const token = await getAuthorizationToken(msalInstance, account, authority, logout);

        if (!token) {
            throw new Error("Failed to acquire authorization token");
        }

        const response = await fetch("/api/orderExport/generate-token", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch token");
        }

        const { token: pdfToken } = await response.json();
        return pdfToken;
    } catch (error) {
        console.error("Error fetching PDF token:", error);
        return null;
    }
};

export default fetchPdfToken;